import React from 'react';
import { Box, Skeleton } from '@mui/material';

interface LoadingOverlayProps {
  loading: boolean;
  children: React.ReactNode;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ loading, children }) => {
  if (loading) {
    return (
      <Box sx={{ p: 3 }}>
        <Skeleton variant="text" width="60%" height={32} sx={{ mb: 2 }} />
        <Skeleton variant="rectangular" width="100%" height={120} sx={{ mb: 2, borderRadius: 1 }} />
        <Skeleton variant="text" width="40%" height={24} />
      </Box>
    );
  }

  return <>{children}</>;
};

export default LoadingOverlay;
